export default __webpack_public_path__ + "static/media/logo.e8ce24f3.png";